/// <amd-module name="Release/Landing/LeftPanel/PipelineSearch/PipelineSearchActionCreator" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssHistoryService } from "VSS/Platform/History";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { IReleaseService } from "Release/Client/Service/Release";
import { ReleaseDefinitionExpands, ReleaseDefinition } from "Release/Client/Contracts/Release";
import { ActionCreatorBase } from "DistributedTask/Flux/Actions";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { PipelineSearchActions } from "./PipelineSearchActions";
import { SelectionActions, IDefinitionSelectionPayload } from "Selection/SelectionActions";
import { MessageActions } from "Release/Landing/HubMessageBar/MessageActions";
import { MessageBarKeys } from "Release/Landing/Constants";
import { IDefinitionSelection } from "Selection/SelectionStore";
import { RmServiceInstanceId } from "Constants";

interface ISearchedDefinitionData {
    releaseDefinitions: ReleaseDefinition[] | undefined | null;
    searchQuery: string;
}

export class PipelineSearchActionCreator extends ActionCreatorBase {
    public static getKey(): string {
        return "release-landing-pipelines-search-actioncreator";
    }

    public initialize(): void {
        this._actions = ActionsHubManager.GetActionsHub<PipelineSearchActions>(PipelineSearchActions);
        this._selectionActions = ActionsHubManager.GetActionsHub<SelectionActions>(SelectionActions);
        this._messageActions = ActionsHubManager.GetActionsHub<MessageActions>(MessageActions);
    }
    public searchReleasePipelines(pageContext: IVssPageContext, searchText: string, selection?: IDefinitionSelection): void {
        if (searchText) {
            this._actions.searchDefinitions.invoke({
                searchResultsLoading: true,
                searchText: searchText,
                searchedDefinitions: []
            });

            this._lastSearchQuery = searchText;
            const additionalProperties = { searchText: searchText };
            pageContext.getService<IVssContributionService>("IVssContributionService")
                .getDataAsync(
                searchPipelinesDataProviderContributionId,
                additionalProperties,
                true,
                RmServiceInstanceId
                )
                .then((result: ISearchedDefinitionData) => {
                    if (result.searchQuery === this._lastSearchQuery) {
                        this._actions.searchDefinitions.invoke({
                            searchResultsLoading: false,
                            searchText: searchText,
                            searchedDefinitions: result.releaseDefinitions || []
                        });

                        this._selectionActions.selectDefinition.invoke({
                            id: -1,
                            noSelection: true
                        } as IDefinitionSelectionPayload);
                    }
                },
                (error) => {
                    this._handleError(error);
                    this._actions.searchDefinitions.invoke({
                        searchResultsLoading: false,
                        searchedDefinitions: [],
                        searchText: ""
                    });
                });
        }
        else {
            this._actions.searchDefinitions.invoke({
                searchResultsLoading: false,
                searchedDefinitions: [],
                searchText: ""
            });

            if (selection && selection.id > 0) {
                this._selectionActions.selectDefinition.invoke({
                    id: selection.id,
                    noSelection: false
                } as IDefinitionSelectionPayload);
            }
        }
    }

    private _handleError(error: any): void {
        let errorMessage: string = error ? error.message || error : "";
        this._messageActions.setMessage.invoke({ key: MessageBarKeys.HubError, value: errorMessage });
    }

    private _lastSearchQuery: string;
    private _actions: PipelineSearchActions;
    private _selectionActions: SelectionActions;
    private _messageActions: MessageActions;
}

const searchPipelinesDataProviderContributionId = "ms.vss-releaseManagement-web.search-definitions-data-provider";
